import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * Resolved recipients for the "Email service desk" button (see api/service-desk-queries.ts). Not a
 * stored document — it is computed per request from the partner company setting and the environment
 * default, so it carries no identity of its own.
 */
@Entity()
export class ServiceDeskRecipients extends AdornisEntity {
  static override _class = 'ServiceDeskRecipients';

  static override resolveID(_entity: ServiceDeskRecipients): string {
    return A.getGloballyUniqueID();
  }

  @Field(() => String)
  to: Maybe<string>;

  @Field(() => [String], { default: v => v ?? [] })
  cc: Maybe<string[]>;
}
